class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    // console.log("Line: " + line + "Quantity: " + quantity + "Name: " + name);
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
       
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('div#drawer-name');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        /*this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));*/

        if (!parsedState.errors) {
          this.updateItemsHtml(parsedState);
        }

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.innerHTML = window.cartStrings.error;
        }
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
  
  updateItemsHtml(html) {    
      var mf = window.variantStrings.mf;
      var total = Shopify.formatMoney(html.items_subtotal_price, mf);
    
      var str = '';
    
      if ( html.item_count > 0 ) {
        document.getElementById("empty-cart-id").style.display = "none";
        html.items.forEach(function(item, index) {
          var v_title = item.variant_title;
          var prod_image = '<div class="card-img var_'+ item.id +'"><a href="'+ item.url +'"></a></div>';
          var prod_title = item.product_title;
          var final_price = item.final_line_price;
          var original_price = item.original_line_price;
          var discounted_price = item.discounted_price;
          var indexNumber = index + 1; 
  
          // build prod price.
          var prod_price = '';
          var original_price = item.original_line_price;
          if (original_price!=final_price) {
            prod_price += '<div><p>' + Shopify.formatMoney(discounted_price,mf) + '</p></div>';
          } else {
            prod_price += '<div><p>' + Shopify.formatMoney(original_price,mf) + '</p></div>';
          }
  
          // build variant.
          var dVariant = '<div class="card_price_wrrap"><dl>';
          if (!item.product_has_only_default_variant) {
              item.options_with_values.forEach(function(variant_item, index) {
                
                  dVariant += '<h4 class="product-option" key="vrnt-'+ index +'">';
                // dVariant += variant_item.name +' : ';
                  dVariant += variant_item.value;
                  dVariant += '</h4>';
                
            });        
          }
         dVariant += '</dl>';
         dVariant += '<p class="card-item-qty ' + (item.handle === 'ossa-gift-card' ? 'gift-product' : '') + '">x '+ item.quantity +'</p>';
         dVariant += '</div>';
          // build quantity form.
          var decIcon = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg>';
          var incIcon = ' <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>';
          
          var qtyStr = '<div class="card_content_bottom btm-item-' + item.id + ' ' + (item.handle === 'ossa-gift-card' ? 'gift-product' : '') + '"><div class="quantity--container"><div class="quentity">';
          qtyStr += '<quantity-input class="quantity">';
          qtyStr += '<button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">Decrease quantity for '+ item.title +'</span>'+ decIcon +'</button>';
          qtyStr += '<input class="quantity__input ossn-quantity__input" type="number" name="updates[]" value="'+ item.quantity +'" min="0" aria-label="Quantity for '+ item.title +'" id="Drawer-quantity-'+ indexNumber +'" data-index="'+ indexNumber +'">';
          qtyStr += '<button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">Increase quantity for '+ item.title +'</span>'+ incIcon +'</button>';
          qtyStr += '</quantity-input>';
          qtyStr += '</div> </div><div class="cart_card_price"><p>'+prod_price+'</p></div></div>';
  
          var removeIcon = '<div class="remove_product_cart"><cart-remove-button id="CartDrawer-Remove-'+ indexNumber +'" data-index="'+ indexNumber +'">';
          removeIcon += '<button class="button button--tertiary" aria-label="Remove '+ item.title +'">';
          removeIcon += '<span class="remove--button--style"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="12.8028" y1="2.19682" x2="2.19617" y2="12.8034" stroke="#ED4A24"></line><line x1="2.1973" y1="2.19674" x2="12.8039" y2="12.8033" stroke="#ED4A24"></line></svg></span></button></cart-remove-button></div></div>';
  
          str += '<div id="CartDrawer-Item-'+ indexNumber + '" class="product-cart-list">';
          str += '<div class="card_details">';
          // str += '<div><p>'+ prod_title +'</p></div>';
          // str += prod_price;
          str += '<div class="middle_content_card ">' + prod_image;   
          str += '<div class="card-content"><div class="top_heading_card">';
          str += '<div><p>'+ prod_title +'</p></div></div>' + dVariant +'<div class="space_between_card"></div>'+ qtyStr + '</div>' + removeIcon +'</div>'; 
          str += '</div></div>';

           $.get('/cart?view=alternat_cart', function(cart, textStatus) {  
          var cart_img = $(cart).find('.card-img.var_'+item.id).html();
          if($(cart).find('.grid_pre_order.product-cart-'+item.id).length > 0){
            var pre_order = $(cart).find('.grid_pre_order.product-cart-'+item.id).find('.pre_order_est_date').html();
            $('<p class="preorder_cart">PREORDER</p><p class="pre_order_est_date">'+pre_order+'</p>').insertBefore(".btm-item-"+item.id);
          }
          setTimeout(function(){
            $('.var_'+item.id).html(cart_img);
          },100)
          });
          
        });
        str += '<div class="related_wrraper_main"></div>';
        document.getElementById("drawer__wrapper").classList.remove("empty-cart");
        document.getElementById("empty-cart-id").style.display = "none";
        document.getElementById("CartDrawer-Checkout").disabled = false;
          // Update Free-Shipping Bar.
           $.get('/cart?view=alternat_cart', function(cart, textStatus) {
            var freeShip = $(cart).find('.free-shipping-notice').html();
            $('.free-shipping-notice').html(freeShip);
            var upsell = $(cart).find('.related_wrraper_main').html();
            $('body').find('.related_wrraper_main').html(upsell);
          });
      } else {
        // show cart is empty
        // console.log('else');
        document.getElementById("empty-cart-id").style.display = "flex";
        var emptyStr = '<div class="product-cart-list drawer__inner-empty">';
        emptyStr += '<div class="empty_cart">';
        emptyStr += '<h2 class="empty_text">Your cart is empty</h2>';
        emptyStr += '<a class="empty-cart-link"  href="/">Start Shopping</a>';
        emptyStr += '</div></div>';
        document.getElementById("empty-cart-id").innerHTML = emptyStr;
        document.getElementById("CartDrawer-Checkout").disabled = true;
        document.getElementById("drawer__wrapper").classList.add("empty-cart");

      }
      
      // update html
      document.getElementById("totals__subtotal-value").innerHTML = total;
      document.getElementById("cart-total").innerHTML = total;
      document.getElementById("bag-count").innerHTML = html.item_count;
      document.getElementById("bagCnt").innerHTML = html.item_count;
      document.getElementById("CartDrawer-CartItems").innerHTML = str;
    }
}

customElements.define('cart-drawer-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};
